import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useState } from "react";
import IwMenu from "../../../app/IwMenu";
import { RemoveFromGroupModal } from "../../common/RemoveFromGroup.modal";

export const subrowActionCell = ({ ...props }) => {
  const { row, handleOpenMoveUserModal } = { ...props };

  const [openRemoveFromCohortModal, setOpenRemoveFromCohortModal] =
    useState(false);

  const cohortTypeLabel = row?.original?.groupType ? `Remove from ${row?.original?.groupType}` : null;

  return (
    <>
      <RemoveFromGroupModal
        open={openRemoveFromCohortModal}
        handleClose={() => {
          setOpenRemoveFromCohortModal(false);
        }}
        cohortTypeLabel={row?.original?.groupType}
        roleID={row?.original?.roleID}
      />
      <IwMenu
        label={<MoreVertIcon fontSize="medium" />}
        tooltipProps={{
          title: "Options"
        }}
        triggerComponentSx={{
          margin: "0 8px",
          padding: "2px 0"
        }}
        items={[
          {
            id: "move-user",
            label: "Move User",
            onClick: () => {
              handleOpenMoveUserModal(row?.original?.roleID);
            }
          },
          {
            id: "remove-from-cohort",
            label: cohortTypeLabel,
            onClick: () => {
              setOpenRemoveFromCohortModal(true);
            }
          }
        ]}
      />
    </>
  );
};
